// extracted by mini-css-extract-plugin
export default {"chat-container":"wvIDCLnMsCBJGwj","mobile":"TL7_3PL3jM_FGag","chat":"oX70jjP3y_C5U_w","desktop":"Kym8oABhkFfs32k"};